import React from "react";
import "./Footer.css";
import logo from "../../assets/thumbnails/logoOnly.png";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <img id="footer-logo" src={logo} alt="Company Logo" />
          <h6>Head Office:</h6>
          <p>
            Flat No. 304, IIE Block, Rajdhani Apartment, Ganeshguri, Guwahati,
            Assam.
          </p>

          <h6>Branch Offices:</h6>
          <ul>
            <li>Sadulla Complex, Thana Road, Howly, Barpeta, Assam.</li>
            <li>
              Room No-02, Sonkuchi, Below Smart Point, Barpeta Town, Assam.
            </li>
            <li>Factory: Dolagaon, Howly-Barpeta PWD Road, Barpeta, Assam.</li>
          </ul>
        </div>

        <div className="footer-section">
          <h6>Contact</h6>
          <ul>
            <li>+91-8761005772</li>
            <li>+91-7399861838</li>
            <li>spirentindia.infra@gmail.com</li>
            <li>spirent028@gmail.com</li>
          </ul>
        </div>

        <div className="footer-section">
          <h6>Working Hours</h6>
          <p>Mon - Sat</p>
          <p>8:00 AM - 05:00 PM</p>
        </div>
      </div>

      <div className="footer-bottom">
        © Spirent India Pvt. Ltd | All Rights Reserved
      </div>
    </footer>
  );
}

export default Footer;
